import { AiGenerationType } from "../ai/aiGenerationType.ts";

import { WireframeFidelity } from "./screen.ts";

export const aiGenerationTypeToFidelityMap = {
  [AiGenerationType.enum.low_fidelity_wireframe]: WireframeFidelity.enum.lofi,
  [AiGenerationType.enum.high_fidelity_wireframe]: WireframeFidelity.enum.hifi,
  [AiGenerationType.enum.high_fidelity_ui]: WireframeFidelity.enum.ui,
} as const satisfies Record<AiGenerationType, WireframeFidelity>;

export const fidelityToAiGenerationTypeMap = {
  [WireframeFidelity.enum.lofi]: AiGenerationType.enum.low_fidelity_wireframe,
  [WireframeFidelity.enum.hifi]: AiGenerationType.enum.high_fidelity_wireframe,
  [WireframeFidelity.enum.ui]: AiGenerationType.enum.high_fidelity_ui,
} as const satisfies Record<WireframeFidelity, AiGenerationType>;
